var render, staticRenderFns
import script from "./CanvasDragAndDropWrapper.vue?vue&type=script&lang=js&"
export * from "./CanvasDragAndDropWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41829230')) {
      api.createRecord('41829230', component.options)
    } else {
      api.reload('41829230', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/CanvasDragAndDropWrapper.vue"
export default component.exports